import AdviserRatingApi from '../../core/api/AdviserRatingApi'
export const VALIDATE_RATING = 'VALIDATE_RATING'
export const SET_METADVISOR = 'SET_METADVISOR'
export const SET_APPOINTADVISOR = 'SET_APPOINTADVISOR'
export const SET_EMAIL = 'SET_EMAIL'
export const SET_EMAILVALIDATION = 'SET_EMAILVALIDATION'
export const SET_RATING = 'SET_RATING'
export const SET_ADVISER_ID = 'SET_ADVISER_ID'
export const SUBMITTING_RATING = 'SUBMITTING_RATING'
export const SUBMITTED_RATING = 'SUBMITTED_RATING'
export const SET_RESPONSE_STATUS = 'SET_RESPONSE_STATUS'
export const RESET_RATING = 'RESET_RATING'

export const validate = (specificComponent) => ({
  type: VALIDATE_RATING,
  specificComponent
})

export const setMetAdviser = (value) => ({
  type: SET_METADVISOR,
  value
})

export const setAppointAdviser = (value) => ({
  type: SET_APPOINTADVISOR,
  value
})

export const setRating = (value, ratingType) => ({
  type: SET_RATING,
  value,
  ratingType
})

export const setEmailValidation = (state, isValid, help) => ({
  type: SET_EMAILVALIDATION,
  state,
  isValid,
  help
})

export const setEmail = (validationResult, value) => ({
  type: SET_EMAIL,
  validationResult,
  value
})

export const setAdviserId = (adviserId) => ({
  type: SET_ADVISER_ID,
  adviserId
})

export const setResponseStatus = (responseStatus) => ({
  type: SET_RESPONSE_STATUS,
  responseStatus
})

// Clears any rating/validation state left over from a previous visit so each rate screen starts
// empty. Without this, stale-but-valid Redux state from an earlier rating leaves Submit enabled
// while the star inputs (which keep their own local state) appear blank.
export const resetRating = () => ({
  type: RESET_RATING
})

export function submitAdviserRating (adviserRating) {
  const api = new AdviserRatingApi()
  const request = api.postAdviserRating(adviserRating)

  return (dispatch) => {
    request.then(function (response) {
      dispatch(api.handleResponse(SUBMITTED_RATING, response))
    })
  }
}

